import { createReducer, on } from "@ngrx/store";
import { CareerResultSchema, FilterFormDataSchema } from "../../schemas/career-matches";
import { 
  bookmarkCareerMatch, 
  setAdeptIDCareerMatches, 
  setCareerGoalByOnetCode, 
  setCareerMatches, 
  updateUserCareerFilterOptions
} from "../actions/careers.action";
import { CAREER_FILTER_DEFAULT_OPTIONS } from "@app/utils/constants";

const initialCareerMatches: CareerResultSchema[] = [];
export const careerMatchesReducer = createReducer(
  initialCareerMatches,
  on(setCareerMatches, (_, action) => action.payload),
  on(bookmarkCareerMatch, (state, action) => {
    return state.map(
      (item, index) => (index === action.index ? { ...item, saved: !item.saved } : item)
    )
  })
);

const initalCareerGoal: string = "";
export const careerGoalReducer = createReducer(
  initalCareerGoal,
  on(setCareerGoalByOnetCode, (_, action) => action.onetCode),
);

const initalFilterOptions: FilterFormDataSchema = CAREER_FILTER_DEFAULT_OPTIONS;
export const createCareerFilterReducer = createReducer(
  initalFilterOptions,
  on(updateUserCareerFilterOptions, (_, action) => action.filter),
);

export const createAdeptIDCareerReducer = createReducer(
  null,
  on(setAdeptIDCareerMatches, (_, action) => action.data),
)